import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { AsyncPipe, DatePipe } from '@angular/common';

import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatGridListModule } from '@angular/material/grid-list';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import moment from 'moment';

import { BehaviorSubject, combineLatestAll, exhaustMap, filter, map, of, scan } from 'rxjs';

import { GestioneCrawlingService } from '../../../services/gestione-crawling.service';
import { InfinityScroll } from '../../../../classes/infinity-scroll';
import { LoadingComponent } from '../../../shared/loading/loading.component';

@Component({
  selector: 'app-crawling-log',
  imports: [MatTableModule, MatProgressSpinnerModule, MatGridListModule, AsyncPipe, DatePipe, LoadingComponent, FormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatSelectModule, MatButtonModule, MatIconModule],
  templateUrl: './crawling-log.component.html',
  styleUrl: './crawling-log.component.scss'
})
export class CrawlingLogComponent {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;

  private readonly crawlingService = inject(GestioneCrawlingService);

  infinityScroll = new InfinityScroll({ pageSize: 10, eventHeight: 52 });

  filters: any = {
    startDate: moment().utc().subtract(7, 'days'),
    endDate: moment().utc(),
    pageSize: 10
  };
  private readonly filterSubject = new BehaviorSubject<any>(this.filters);

  logsCallback$ = of(
    this.filterSubject.asObservable(),
    this.infinityScroll.scrollSubject.asObservable()
  );

  logs$ = this.logsCallback$.pipe(
    combineLatestAll(),
    filter(() => this.infinityScroll.allDataLoaded === false),
    exhaustMap(() => {
      const params = {...this.filters,
        startDate: this.filters.startDate ? this.filters.startDate.unix() * 1000 : null,
        endDate: this.filters.endDate ? this.filters.endDate.unix() * 1000 : null,
        pageToken: this.infinityScroll.nextPageToken
      };
      
      return this.crawlingService.getCrawlingLog(params).pipe(
        map(response => {
          this.infinityScroll.onDataLoaded(response.nextPageAsync.done, response.nextPageToken);
          return response.values;
        })
      )
    }),
    scan((allData, newPageData) => {
      if (!this.infinityScroll.loadFromScroll) return newPageData;

      return [...allData, ...newPageData]
    })
  )

  displayedColumns: string[] = ['logName', 'payload', 'severity', 'timestamp'];

  filterLogs() {
    this.infinityScroll.resetScroll(this.scrollContainer, true);
    this.filterSubject.next(this.filters);
  }

  onTableScroll(event: any) {
    this.infinityScroll.onScroll(event);
  }
}
